/* global document */
document.documentElement.classList.add('js-enabled');
const toggle = document.querySelector('.nav-toggle');
const navigation = document.querySelector('.primary-nav');
toggle?.addEventListener('click', () => {
  const open = navigation.classList.toggle('open');
  toggle.setAttribute('aria-expanded', String(open));
  toggle.querySelector('.sr-only').textContent = open ? 'Close menu' : 'Open menu';
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !navigation?.classList.contains('open')) return;
  navigation.classList.remove('open');
  toggle.setAttribute('aria-expanded', 'false');
  toggle.querySelector('.sr-only').textContent = 'Open menu';
  toggle.focus();
});

const mobileActions = document.querySelector('[data-mobile-actions]');
const homeHero = document.querySelector('.somm-photo-hero');

if (mobileActions) {
  let frameRequested = false;

  const updateMobileActions = () => {
    frameRequested = false;
    const heroIsClear = !homeHero || homeHero.getBoundingClientRect().bottom <= window.innerHeight;
    mobileActions.classList.toggle('is-visible', heroIsClear);
  };

  const requestMobileActionsUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateMobileActions);
  };

  updateMobileActions();
  window.addEventListener('scroll', requestMobileActionsUpdate, { passive: true });
  window.addEventListener('resize', requestMobileActionsUpdate, { passive: true });
}
